import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { PpApiGatewayService } from '@app/pp-api-gateway.service';
import { Invoice } from '@app/types/invoice';
import { SessionStorage } from '@app/types/session-storage.enum';
import { UserService } from '@app/user.service';

@Component({
  selector: 'pp-invoice-table',
  templateUrl: './invoice-table.component.html',
  styleUrls: ['./invoice-table.component.scss'],
})
export class InvoiceTableComponent implements OnInit {
  columnsDesktop = [
    'number',
    'date',
    'amount',
    'paymentAmount',
    'adjustments',
    'tax',
    'balance',
    'downloadUrl',
  ];
  columnsMobile = ['mobile'];
  dataSource: Array<Invoice>;
  isDesktop = true;
  xhrInProgress = true;
  locale = sessionStorage.getItem(SessionStorage.Language);
  showTaxColumn = false;

  constructor(
    private breakPointObserver: BreakpointObserver,
    private ppApiGateway: PpApiGatewayService,
    private userService: UserService
  ) {}

  ngOnInit() {
    if (!this.showTaxColumn) {
      this.columnsDesktop.splice(this.columnsDesktop.indexOf('tax'), 1);
    }

    this.breakPointObserver
      .observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
      .subscribe((result) => {
        this.isDesktop = result.matches;
      });

    this.ppApiGateway
      .getInvoicesByContactId(this.userService.contactId)
      .subscribe(
        (data) => {
          this.xhrInProgress = false;
          this.dataSource = data;
        },
        (err) => {
          console.error(err);
          this.xhrInProgress = false;
        }
      );
  }
}
